// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__1X1Lt","dragIcon":"SortableItem_dragIcon__2XKCh","disabled":"SortableItem_disabled__3MPQU"};